import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'FreezeRowColumnIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-freeze-row-column",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15 3l-12 12"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9.5 3l-6 6"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 3.5l-5.5 5.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 15l-5 5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M21 9h-12v12"
    }, null), _createTextVNode(" ")]);
  }
};